import { lazy, Suspense } from 'react'
import { Navigate } from 'react-router'

import { preloadNamespaces } from '@/i18n/route-namespaces'
import { useFeatureFlags } from '@/stores/use-feature-flags'

import { RouteFallback } from '../route-fallback'

const FinnPage = lazy(async () => {
  await preloadNamespaces(['finn'])

  const { FinnPage: Component } = await import('@/pages/finn')

  return { default: Component }
})

function FinnRouteGuard() {
  const { featureFlags, isLoaded } = useFeatureFlags()

  if (!isLoaded) {
    return <RouteFallback />
  }

  if (!featureFlags.finn) {
    return <Navigate to="/companies" replace />
  }

  return (
    <Suspense fallback={<RouteFallback />}>
      <FinnPage />
    </Suspense>
  )
}

export const finnRoutes = {
  path: 'finn',
  element: <FinnRouteGuard />,
}
